package com.ives.modules.measurements;

import com.er453r.hxcompo.Component;
import com.ives.utils.math.Vector2D;

@:allow(com.ives.modules.measurements.Measurements)
class MeasurementInfo extends Component {
	public function setLocalPosition(local:Vector2D) {
		viewElement.style.top = '${local.y}px';
		viewElement.style.left = '${local.x}px';
	}
}
